export const RESET_APPLICATION_DETAIL = 'applicationDetail/RESET_APPLICATION_DETAIL';
